import React from "react";

export default function PeriodButton({isSelected=false, title, iconClassName, onClick}) {
    return (
        <button className={"icon-btn" + (isSelected ? " selected" : "")} title={title}
                onClick={onClick}><i className={iconClassName}/>
        </button>
    )
    ;
}